import { render, staticRenderFns } from "./ClusterSpendBarChart.vue?vue&type=template&id=6d8bf851&"
import script from "./ClusterSpendBarChart.vue?vue&type=script&lang=ts&"
export * from "./ClusterSpendBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports